import { NgModule } from '@angular/core';
import { RestaurantHeaderComponent } from './restaurant-header/restaurant-header.component';
import { RestaurantFooterComponent } from './restaurant-footer/restaurant-footer.component';
import { FoodItemComponent } from './food-item/food-item.component';
import { MenuCardComponent } from './menu-card/menu-card.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { SearchComponent } from 'src/app/shared/components/search/search.component';
import { DropdownDirective } from 'src/app/shared/directives/dropdown.directive';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CouponComponent } from 'src/app/modules/shop/components/coupon/coupon.component';


@NgModule({
  declarations: [
    RestaurantHeaderComponent,
    RestaurantFooterComponent,
    MenuCardComponent,
    FoodItemComponent,
    CouponComponent
  ],
  entryComponents: [
    RestaurantHeaderComponent,
    FoodItemComponent

  ],
  exports: [
    RestaurantHeaderComponent,
    RestaurantFooterComponent,
    FoodItemComponent,
    MenuCardComponent,
    CouponComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    RouterModule,
    TranslateModule

  ],
  providers: [],
  bootstrap: []
})
export class RestaurantSharedModule { }

